import { WizBrowserExport } from 'wiz-components'
import moment from 'moment';

const tableHead = [
  {
    headerName: '',
    width: 30,
    field: 'rowIndex',
    hidden: true,
    suppressMovable: true,
    cellStyle: {
      textAlign: 'center',
      padding: '5px 0',
      color: '#595959',
      backgroundColor: '#f0f0f0',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: '500',
      boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
    },
  },
  {
    headerName: '细项名称',
    field: 'optionName',
    width: 25,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: { vertical: 'bottom', horizontal: 'left' },
    },
  },
  {
    headerName: '达标情况',
    field: 'standardSituation',
    width: 25,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: { vertical: 'bottom', horizontal: 'left' },
    },
  },
  // {
  //   headerName: '点评内容',
  //   field: 'commentContent',
  //   width: 30,
  //   cellStyle: {
  //     textAlign: 'center',
  //   },
  //   style: {
  //     alignment: { vertical: 'bottom', horizontal: 'left' },
  //   },
  // },
  // {
  //   headerName: '反馈内容',
  //   field: 'feedbackContent',
  //   width: 25,
  //   cellStyle: {
  //     textAlign: 'center',
  //   },
  //   style: {
  //     alignment: { vertical: 'bottom', horizontal: 'left' },
  //   },
  // }
];


export default function (dataList) {

  const _columns = tableHead.filter((_, index) => index)
  let newDate = moment(new Date()).format("YYYYMMDDHHmmss")
  WizBrowserExport({
    title: `摄像头检核详情`,
    sheetName: `摄像头检核详情`,
    columns: _columns,
    rows: dataList,
    filename: `摄像头检核详情${newDate}.xlsx`,
  })
}